import React, { useEffect, useState } from 'react';

import ComboBox from '../../../../../components/ComboBox';
import CollapsableSection from '../../../../../components/CollapsibleSection';
import ButtonForm from '../../../../../components/ButtonForm';
import InputForm from '../../../../../components/InputForm';
import WidgetHeaderStyleFields from '../../../../../components/WidgetHeaderStyleFields';
import DropdownSelectableList from '../../../../../components/icons/DropdownSelectableList';
import SelectionForm from '../../../../../components/SelectionForm';

import CheckIco from '../../../../../components/icons/CheckIco';
import TrashIco from '../../../../../components/icons/TrashIco';
import AddIco from '../../../../../components/icons/AddIco';

import Spinner from '../../../../../components/Spinner';
import { useAuth } from '../../../../../providers/AuthContext';
import { useAppContext } from '../../../../../providers/AppContext';
import { useNavigate } from 'react-router-dom';
import { useWidgets } from '../../../../../providers/WidgetContext';
import { useDashboards } from '../../../../../providers/DashboardContext';
import { createWidget, getWidgetById, updateWidget } from '../../../../../services/apiWidgests';
import { getAllParameters } from '../../../../../services/apiProcessParameteres';
import { translateDatePicker } from '../../../../utils';
import { useProcesses } from '../../../../../providers/ProcessesContext';
import Toggle from '../../../../../components/forms/Toggle';

const ColumnField = ({ header , onDelete=() =>{}}) => {
  // Extraer datos del target
  const aliasOrKey = header?.target?.alias || header?.target?.key || "Sin nombre";
  const key = header?.target?.key || "";
  
  // Extraer datos del where
  const whereField = header?.where ? Object.keys(header.where)[0] : null;
  const whereCondition = whereField ? header.where[whereField] : null;
  const operator = whereCondition ? Object.keys(whereCondition)[0] : null;
  const value = whereCondition ? whereCondition[operator] : null;

  // Traducir operador para mostrar de forma legible
  const operatorSymbol =
    operator === "equal" ? "=" :
    operator === "notEqual" ? "≠" :
    operator === "greater" ? ">" :
    operator === "less" ? "<" :
    operator || "";

  return (
    <div className="flex justify-between items-center w-full mr-3 border rounded-md p-2 bg-gray-50 hover:bg-gray-100 transition">
      {/* Alias o Key */}
      <div className="flex basis-1/3 items-center gap-1 text-gray-800 font-medium">
        <span>{aliasOrKey}</span>
      </div>

      {/* Where condition */}
      <div className="basis-1/3 text-sm text-gray-500 truncate">
        {whereField && operator && value
          ? `${whereField} ${operatorSymbol} ${value}`
          : "—"}
      </div>

      {/* Key + eliminar */}
      <div className="flex items-center gap-2 basis-1/3 justify-end">
        <span className="text-gray-400 text-xs">{key}</span>
        <button
          className="p-1 hover:bg-red-50 rounded-full"
          onClick={() => onDelete(header)}
        >
          <TrashIco fill="red" className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

function OEEForm({onSubmit = () => {}, id}) {
  const {auth} = useAuth();
  const {addToast} = useAppContext();
  const navigate = useNavigate();
  
  const { addCard, assignSpace } = useWidgets();
  const { dashboard , selectedTab} = useDashboards();
  
  const [processList, setProcessList] = useState([]);
  const [selectedEfficiencyProcess, setSelectedEfficiencyProcess] = useState();
  const [selectedQualityProcess, setSelectedQualityProcess] = useState();
  const [selectedDisponibilityProcess, setSelectedDisponibilityProcess] = useState();
  const [disponibilityParameters, setDisponibilityParameters] = useState();
  const [efficiencyParameters, setEfficiencyParameters] = useState();
  const [qualityParameters, setQualityParameters] = useState();

  const {menuItems} = useProcesses();
  const [dataRange, setDataRange] = useState('Asignar por dashboard');
  const [title, setTitle] = useState('');
  const [validate, setValidate] = useState(false);
  const [conf, setConf] = useState();
  const [isRate, setIsRate] = useState(false);
  const [toCompare, setToCompare] = useState();
  const [valueToCompare, setValueToCompare] = useState();
  const [aggregation, setAggregation] = useState("add");
  const [timespan, setTimespan] = useState("hours");
  const [interval, setInterval] = useState(1);
  const [stage,setStage] = useState("form");

  const aggregationOptions = {
    "add": "Suma",
    "mean": "Promedio",
    "max": "Máximo",
    "min": "Mínimo",
    "count": "Conteo"
  }
  const timeOptions = {
    "minutes": "Minutos",
    "hours": "Horas",
    "days": "Días",
    "weaks": "Semanas",
    "months": "Meses"
  }
  const OPERATOR_OPTIONS = [
    { label: "Igual a", value: "equal" },
    { label: "Diferente de", value: "notEqual" }
  ];

  const graphTypes = {
    "line": "Gráfico de linea",
    "VBars": "Gráfico de barras vertical",
    "HBars": "Gráfico de barras horizontal"
  }

//colores
  const colorOptions = {
    "pastel": "Paleta pastel",
    "blue": "Paleta azul",
    "red": "Paleta roja",
    "fixed": "Color fijo"
  }

  //backend flags
  const [loading, setLoading] = useState(true);
  const [fetchingDisponibilityParameters, setFetchingDisponibilityParameters] = useState(true);
  const [fetchingEfficiencyParameters, setFetchingEfficiencyParameters] = useState(true);
  const [fetchingQualityParameters, setFetchingQualityParameters] = useState(true);
  const [creatingWidget, setCreatingWidget] = useState(false);
  const [fetchingWidgetInfo, setFetchingWidgetInfo] = useState(true);

  //obtener info existente del widget
  const refreshWidgetInfo = () => {
    async function fetchWigdet(){
      const widget = await getWidgetById(id, auth?.token);
      return widget; 
    }
    try {
      setFetchingWidgetInfo(true);
      fetchWigdet().then(response => {
        console.log(response.configuration)
        setConf(response.configuration)
        setSelectedDisponibilityProcess(response.configuration.disponibility.process.id)
        setSelectedEfficiencyProcess(response.configuration.efficiency.process.id)
        setSelectedQualityProcess(response.configuration.quality.process.id)
        setTimespan(response.configuration.timespan)
        setAggregation(response.configuration.aggregation)
        setIsRate(response.configuration.isRate || false)
        setInterval(response.configuration.interval)
        //setDataRange(response.configuration.dateRange.selectedRange === "byDashboard" ? "Asignar por dashboard": response.configuration.dateRange.selectedRange)
        setFetchingWidgetInfo(false);
        setTitle(response.title)
      }).catch(error => {
        if (error.response.status === 404){
          console.log("Widget no encontrado")
        }
        else if (error.response.status === 500){
          console.log("Error en el servidor, intente nuevamente")
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error,typeof(error));
      setFetchingWidgetInfo(false);
    }
  }
  
  const refreshParameters = (selectedProcess, block) => {
    async function fetchParameters(){
      const parameters = await getAllParameters(selectedProcess, auth?.token);
      return parameters;
    }
    try {
      if (block === "disponibility"){
        setFetchingDisponibilityParameters(true);
      }
      if (block === "efficiency"){
        setFetchingEfficiencyParameters(true);
      }
      if (block === "quality"){
        setFetchingQualityParameters(true);
      }
      
      fetchParameters().then(response => {
        console.log(console.log(response))
        if (block === "disponibility"){
          setDisponibilityParameters(response.map(parameter => {
            return {
              key: parameter.key,
              alias: parameter.alias,
              type: parameter.datatype
            }
          }));
          setFetchingDisponibilityParameters(false);
        }
        if (block === "quality"){
          setQualityParameters(response.map(parameter => {
            return {
              key: parameter.key,
              alias: parameter.alias,
              type: parameter.datatype
            }
          }));
          setFetchingQualityParameters(false);
        }
        if (block === "efficiency"){
          setEfficiencyParameters(response.map(parameter => {
            return {
              key: parameter.key,
              alias: parameter.alias,
              type: parameter.datatype
            }
          }));
          setFetchingEfficiencyParameters(false);
        }
        
      }).catch(error => {
        if (error.response.status === 404){
          addToast("Proceso no encontrado",3)
        }
        else if (error.response.status === 500){
          addToast("Error en el servidor, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error, "a", typeof(error));
      if (block === "disponibility"){
        setFetchingDisponibilityParameters(false);
      }
      if (block === "efficiency"){
        setFetchingEfficiencyParameters(false);
      }
      if (block === "quality"){
        setFetchingQualityParameters(false);
      }
    }
  }

  const createWidgetDB = () => {
    async function fetchWidget(){
      const position= assignSpace();
      const widget = await createWidget({
        type: "processOEE",
        title: title,
        description: "",
        configuration: conf,
        dashboardId: dashboard._id,
        x: position.x,
        y: position.y,
        width: 200,
        height: 200,
        selectedTab
      }, auth?.token);
      
      return widget;
    }
    try {
      setCreatingWidget(true);
      fetchWidget().then(response => {
        console.log(console.log(response));
        addCard (
          response._id,
          response.title,
          response.type,
          response.dashboardId,
          
        )
        onSubmit();
        setCreatingWidget(false);
        addToast("Widget "+ title + " creado exitosamente.",1)
      }).catch(error => {
        console.log(error)
        if (error.response.status === 404){
          addToast("Proceso no encontrado",3)
        }
        else if (error.response.status === 500){
          addToast("Error en el servidor, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error, "a", typeof(error));
      setCreatingWidget(false);
    }
  }

  const editWidgetDB = () => {
    async function saveWidget(){

      const widget = await updateWidget(id,{
        type: "processOEE",
        title: title,
        description: "",
        configuration: conf,
        /* dashboardId: dashboard._id,
        x: position.x,
        y: position.y,
        width: 200,
        height: 200, */
      }, auth?.token);
      
      return widget;
    }
    try {
      setCreatingWidget(true);
      saveWidget().then(response => {
        console.log(console.log(response));
        
        onSubmit();
        setCreatingWidget(false);
        addToast("Widget "+ title + " editado exitosamente.",1);
      }).catch(error => {
        console.log(error)
        if (error.response.status === 404){
          addToast("Proceso no encontrado",3)
        }
        else if (error.response.status === 500){
          addToast("Error en el servidor, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error, "a", typeof(error));
      setCreatingWidget(false);
    }
  }

  /* const selectVariableToCompare = (selectedItems) => {
    if (parameters && selectedItems){
      const selectedToCompare = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
      let tempConf = {...conf}
      tempConf.variableToCompare = selectedToCompare
      setConf({...tempConf})
    }
    
  } */

  /*c onst selectGroupList = (selectedItems) => {
    if (parameters && selectedItems){
      const groupList = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
      let tempConf = {...conf}
      tempConf.groupList = groupList
      setConf({...tempConf})
    }
  }

  const deleteToCompare = (selectedItems) => {
    if (parameters && selectedItems){
      let tempConf = {...conf}
      tempConf.variableToCompare = undefined
      setConf({...tempConf})
    } 
  }

  const deleteGroupList = (selectedItems) => {
    if (parameters && selectedItems){
      let tempConf = {...conf}
      tempConf.groupList = undefined
      setConf({...tempConf})
    } 
  }

  const selectConformValue = (selectedItems) => {
    if (parameters && selectedItems){
      const selectedValue = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
      let tempConf = {...conf}
      tempConf.valueToCompare = selectedValue
      setConf({...tempConf})
    }
  }
  const deleteConformValue = (selectedItems) => {
    if (parameters && selectedItems){
      let tempConf = {...conf}
      tempConf.conformValue = undefined
      setConf({...tempConf})
    } 
  }

  const selectNoConformValue = (selectedItems) => {
    if (parameters && selectedItems){
      const selectedValue = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
      let tempConf = {...conf}
      tempConf.noConformValue = selectedValue
      setConf({...tempConf})
    }
  }
  const deleteNoConformValue = (selectedItems) => {
    if (parameters && selectedItems){
      let tempConf = {...conf}
      tempConf.noConformValue = undefined
      setConf({...tempConf})
    } 
  }
 */
  const handleChangeIsRate = (rate) => {
    setIsRate(rate);
    let tempConf = {...conf}
    tempConf.isRate = rate
    setConf({...tempConf})
  }

  const handleProcessChange = (selectedProcess, block) => {
    let tempConf = {...conf}
    if (block === "efficiency"){
      tempConf.efficiency.realValue = undefined;
      tempConf.efficiency.idealValue = undefined;
      tempConf.efficiency.process = {
        id: selectedProcess,
        name: processList[selectedProcess]
      }
    }
    if (block === "quality"){
      tempConf.quality.conformValue = undefined;
      tempConf.quality.noConformValue = undefined;
      tempConf.quality.reValue = undefined;
      tempConf.quality.process = {
        id: selectedProcess,
        name: processList[selectedProcess]
      }
    }
    if (block === "disponibility"){
      tempConf.disponibility.runValue = undefined;
      tempConf.disponibility.stopValue = undefined;
      tempConf.disponibility.process = {
        id: selectedProcess,
        name: processList[selectedProcess]
      }
    }
    
    setConf({...tempConf})
  }
  const handleDataRangeChange = (selectedRange) => {
    setDataRange(translateDatePicker(selectedRange));
    let tempConf = {...conf}
    tempConf.dateRange = selectedRange
    setConf({...tempConf})
  }
  const handleDecimalsChange = (decimals) => {
    let tempConf = {...conf}
    tempConf.nDecimals = decimals
    setConf({...tempConf})
  }
  const handleHasInterval = (hasInterval) => {
    let tempConf = {...conf}
    tempConf.hasInterval = hasInterval
    setConf({...tempConf})
  }
  const handleGraphType = (graphType) => {
    let tempConf = {...conf}
    tempConf.graphType = graphType
    setConf({...tempConf})
  }
  
  const handleChangeWidgetName = (name) => {
    setTitle(name)
  }
  const handleChangeAggregation = (aggregation) => {
    let tempConf = {...conf}
    tempConf.aggregation = aggregation
    setConf({...tempConf})
  }
  const handleChangeInterval = (interval) => {
    let tempConf = {...conf}
    tempConf.interval = Number(interval)
    setConf({...tempConf})
  }
  const handleChangeTimespan = (timespan) => {
    let tempConf = {...conf}
    tempConf.timespan = timespan
    setConf({...tempConf})
  }
  const handleCreateWidget = () =>{
    createWidgetDB();
  }
  const handleEditWidget = () =>{
    editWidgetDB();
  }

  // Handlers para conformValue

  // ================== HANDLERS ==================

  // Buscar parámetro por alias o key
  const findParam = (list, selected) =>
    list.find(p => p?.alias === selected || p?.key === selected);

  // Setear campo objetivo (target)
  const setTargetField = (category, valueName, selectedField, paramList) => {
    const param = findParam(paramList, selectedField);
    setConf(prev => ({
      ...prev,
      [category]: {
        ...prev[category],
        [valueName]: {
          ...((prev[category] && prev[category][valueName]) || {}),
          target: param
            ? {
                key: param.key,
                alias: param.alias || param.key,
                type: param.type
              }
            : undefined,
          where: undefined
        }
      }
    }));
  };

  // Setear campo del WHERE
  const setWhereField = (category, valueName, selectedField, paramList) => {
    const param = findParam(paramList, selectedField);
    if (!param?.key) return;
    setConf(prev => ({
      ...prev,
      [category]: {
        ...prev[category],
        [valueName]: {
          ...((prev[category] && prev[category][valueName]) || {}),
          where: { [param.key]: { equal: "" } }
        }
      }
    }));
  };

  // Setear operador del WHERE
  const setWhereOperator = (category, valueName, operator) => {
    setConf(prev => {
      const where = prev?.[category]?.[valueName]?.where;
      if (!where) return prev;
      const field = Object.keys(where)[0];
      if (!field) return prev;
      return {
        ...prev,
        [category]: {
          ...prev[category],
          [valueName]: {
            ...prev[category][valueName],
            where: { [field]: { [operator]: "" } }
          }
        }
      };
    });
  };

  // Setear valor del WHERE
  const setWhereValue = (category, valueName, value) => {
    setConf(prev => {
      const where = prev?.[category]?.[valueName]?.where;
      if (!where) return prev;
      const field = Object.keys(where)[0];
      if (!field) return prev;
      const operator = Object.keys(where[field] || {})[0];
      if (!operator) return prev;

      return {
        ...prev,
        [category]: {
          ...prev[category],
          [valueName]: {
            ...prev[category][valueName],
            where: { [field]: { [operator]: value } }
          }
        }
      };
    });
  };

  // ----------------- ELIMINAR (GENÉRICO) -----------------
  const deleteValue = (category, valueName) => {
    setConf(prev => {
      if (!prev || !prev[category]) return prev;
      // clonamos para no mutar el estado original
      const newCategory = { ...prev[category] };
      // eliminar la propiedad concreta
      delete newCategory[valueName];
      return {
        ...prev,
        [category]: newCategory
      };
    });
  };


  const deleteConformValue = () => deleteValue("quality", "conformValue");
  const deleteNoConformValue = () => deleteValue("quality", "noConformValue");
  const deleteReValue = () => deleteValue("quality", "reValue");
  const deleteQATimeVar = () => deleteValue("quality", "timeVar");

  const deleteRunValue = () => deleteValue("disponibility", "runValue");
  const deleteStopValue = () => deleteValue("disponibility", "stopValue");
  const deleteDispoTimeVar = () => deleteValue("disponibility", "timeVar");

  const deleteRealValue = () => deleteValue("efficiency", "realValue");
  const deleteIdealValue = () => deleteValue("efficiency", "idealValue");
  const deleteEffTimeVar = () => deleteValue("efficiency", "timeVar");

  const renderStage = (category, valueName, selectedProcess, parameters, headerText) => (
    <div className="flex flex-col gap-2 h-[25rem] relative overflow-auto">
      <div className="flex flex-col flex-grow gap-2">
        <span className="font-semibold text-lg">
          {processList[selectedProcess]} {headerText}
        </span>

        <div className='w-full flex gap-2 items-center'>
          <div className='basis-1/6'>Valor objetivo: </div>
          {/* Campo objetivo */}
          <DropdownSelectableList
            items={parameters
              ?.filter(p => p.type === "numeric" || p.type === "time")
              ?.map(p => p.alias || p.key)}
            multiSelect={false}
            setItems={(selected) =>
              setTargetField(category, valueName, selected, parameters)
            }
          />
        </div>
        
        <div className='w-full flex gap-2 items-center'>
           <div className='basis-1/6'>Donde: </div>
            {/* Campo filtro */}
            <DropdownSelectableList
              items={parameters?.map(p => p.alias || p.key)}
              multiSelect={false}
              setItems={(selected) =>
                setWhereField(category, valueName, selected, parameters)
              }
            />
        </div>
        

        {/* Operador + Valor */}
        {conf?.[category]?.[valueName]?.where && (() => {
          const where = conf[category][valueName].where;
          const field = Object.keys(where || {})[0];
          const operator = field ? Object.keys(where[field])[0] : "";
          const value = operator ? where[field][operator] : "";

          return (
            <>
              <select
                className="border px-2 py-1 rounded w-full"
                value={operator}
                onChange={(e) =>
                  setWhereOperator(category, valueName, e.target.value)
                }
              >
                <option value="">Seleccione un operador</option>
                {OPERATOR_OPTIONS.map(op => (
                  <option key={op.value} value={op.value}>{op.label}</option>
                ))}
              </select>

              <input
                type="text"
                placeholder="Valor"
                className="border px-2 py-1 rounded w-full mt-2"
                value={value}
                onChange={(e) =>
                  setWhereValue(category, valueName, e.target.value)
                }
              />
            </>
          );
        })()}
      </div>

      <div className="flex-none sticky bottom-0 bg-white p-2 shadow-lg">
        <div className="flex w-full justify-end">
          <ButtonForm text="Guardar" enabled={true} action={() => setStage("form")} />
        </div>
      </div>
    </div>
  );

  const selectTimeVarForCategory = (category, selectedItems, parameters) => {
    if (!parameters || !selectedItems) return;

    // Encuentra el parámetro seleccionado
    const selectedParam = parameters.find(p => selectedItems.includes(p.alias || p.key));
    if (!selectedParam) return;

    // Copia del conf actual
    let tempConf = { ...conf };

    // Guarda la variable dentro de la categoría
    tempConf[category] = {
      ...tempConf[category],
      timeVar: {
        key: selectedParam.key,
        alias: selectedParam.alias || selectedParam.key,
        type: "date",
      },
    };

    // Actualiza el estado
    setConf(tempConf);
  };

  const renderTimeVarStage = (category, selectedProcess, parameters, headerText) => {
  return (
    <div className="flex flex-col gap-2 h-[25rem] relative overflow-auto">
      <div className="flex flex-col flex-grow gap-2">
        <span className="font-semibold text-lg">
          {processList[selectedProcess]} {headerText}
        </span>

        <div className="w-full flex gap-2 items-center">
          <div className="basis-1/6">Variable de tiempo:</div>
          <DropdownSelectableList
            items={parameters.filter(p => p.type === "date").map(p => p.alias || p.key)}
            multiSelect={false}
            setItems={(selected) => selectTimeVarForCategory(category, selected, efficiencyParameters)}
          />

        </div>
      </div>

      <div className="flex-none sticky bottom-0 bg-white p-2 shadow-lg">
        <div className="flex w-full justify-end">
          <ButtonForm text="Guardar" enabled={true} action={() => setStage("form")} />
        </div>
      </div>
    </div>
  );
};

  const selectColorPalette = (selectedColor) => {
    if (selectedColor){
      let tempConf = {...conf}
      tempConf.colorPalette = selectedColor
      setConf({...tempConf})
    }
  }
  const selectFixedColor = (selectedColor) => {
    if (selectedColor){
      let tempConf = {...conf}
      tempConf.fixedColor = selectedColor
      setConf({...tempConf})
    }
  }
  const selectTextColor = (selectedColor) => {
    if (selectedColor){
      let tempConf = {...conf}
      tempConf.textColor = selectedColor
      setConf({...tempConf})
    }
  }

  useEffect( () => {
    if (selectedDisponibilityProcess){
      //limpiar headers actuales
      //cargar los parametros
      refreshParameters(selectedDisponibilityProcess, "disponibility");
      //actualizar la configuracion
      handleProcessChange(selectedDisponibilityProcess, "disponibility");

    }
  }, [selectedDisponibilityProcess]);

  useEffect( () => {
    if (selectedEfficiencyProcess){
      //limpiar headers actuales
      //cargar los parametros
      refreshParameters(selectedEfficiencyProcess,  "efficiency");
      //actualizar la configuracion
      handleProcessChange(selectedEfficiencyProcess,  "efficiency");

    }
  }, [selectedEfficiencyProcess]);
  
  useEffect( () => {
    if (selectedQualityProcess){
      //limpiar headers actuales
      //cargar los parametros
      refreshParameters(selectedQualityProcess, "quality");
      //actualizar la configuracion
      handleProcessChange(selectedQualityProcess, "quality");

    }
  }, [selectedQualityProcess]);

  useEffect( () => {
    const bdConf = {
      efficiency: {
        process: undefined,
        realValue: undefined,
        idealValue: undefined,
        groupList: undefined, 
      },
      disponibility: {
        process: undefined,
        runValue: undefined,
        stopValue: undefined,
        groupList: undefined, 
      },
      quality: {
        process: undefined,
        conformValue: undefined,
        noConformValue: undefined,
        reValue: undefined,
        groupList: undefined, 
      },
      dateRange: {
        "activeTab": "customDates",
        "selectedRange": "byDashboard"
      },
      nDecimals: 2,
      isRate: false,
      dateFormat: "mm/dd/yy - hh:mm:ss",
      graphType : "line",
      colorPalette: "fixed",
      fixedColor: "#4287f5",
      textColor: "#000000"
    }

    setLoading(true);
    //cargar campos
    //cargar conf
    let processOptions = {}
    menuItems.slice(1).map(element => 
      processOptions[element.id] = element.label
    )
    console.log(processOptions);
    if(id) {
      refreshWidgetInfo()
    }
    else{
      setConf(bdConf);
      
    }
    setProcessList(processOptions);
    setLoading(false);
  }, []);
  useEffect( () => {
    if (stage === "form"){

    }
    if (stage === "columnSection"){

    }
  }, [])

  useEffect(() => {
    const basicFieldsValid =
      title !== "" &&
      conf?.efficiency?.process &&
      conf?.efficiency?.idealValue &&
      conf?.efficiency?.realValue &&
      conf?.disponibility?.process &&
      conf?.disponibility?.runValue &&
      conf?.disponibility?.stopValue &&
      conf?.quality?.process &&
      conf?.quality?.conformValue &&
      conf?.quality?.noConformValue &&
      conf?.quality?.reValue &&
      conf?.dateRange &&
      conf?.nDecimals;

    if (basicFieldsValid ) {
      setValidate(true);
    } else {
      console.log(
        "title:", !title,
        "process:", !conf?.process,
        "efficiency:", !conf?.efficiency,
        "disponibility:", !conf?.disponibility,
        "quality:", !conf?.quality,
        "dateRange:", !conf?.dateRange,
        "nDecimals:", !conf?.nDecimals,
        "timespan:", !conf?.timespan,
        "interval:", !conf?.interval,
        "hasInterval:", conf?.hasInterval
      );
      console.log(conf);
      setValidate(false);
    }
  }, [conf, title]);


  useEffect( () => {
    if (id){
      refreshWidgetInfo()
    }
    setFetchingWidgetInfo(false)
    
  }, [id])

  return (
    <>
     {stage === "form" && (
      <>
        {conf && !fetchingWidgetInfo && (
            <div className='flex flex-col gap-2 h-[35rem] relative overflow-auto'>
              <div className=' flex flex-col flex-grow gap-2'>
                <CollapsableSection title={"Datos"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' open={true} border={false}>
                  <div className='flex flex-col w-full gap-2'>
                    {/* Disponibilidad */}
                    <CollapsableSection 
                      CustomTitleBar={() => (
                        <span>Disponibilidad</span>
                      )}
                      titleBgColor='bg-aliceblue'
                      titleTextColor='text-gray'
                      open={true}
                    >
                      <div className='w-full flex flex-col px-4 gap-2'>
                        <div className='flex justify-between items-center'>
                          <div className='w-[45%]'>
                            <SelectionForm
                              text="Proceso" 
                              options={Object.keys(processList)} 
                              mask={processList} 
                              value={selectedDisponibilityProcess}
                              onChange={event => setSelectedDisponibilityProcess(event)}
                              AppendClassName='-mb-5'
                              error={!!selectedDisponibilityProcess && !fetchingDisponibilityParameters && disponibilityParameters.length=== 0 ? 'El proceso no tiene parametros creados' : ""}
                            /> 
                          </div>
                          <div className='relative flex '>
                            <span className='absolute text-sm text-wrap'></span>
                          </div>
                          
                        </div>

                          <CollapsableSection
                            title={"Valor produccion (datos numéricos)"}
                            titleBgColor='bg-aliceblue'
                            titleTextColor='text-gray'
                            open={true}
                          >
                            <div className='w-full flex flex-col px-4'>
                              { conf?.disponibility?.runValue && (
                                <ColumnField header={conf.disponibility.runValue} onDelete={deleteRunValue}/>
                              )}
                              { !conf?.disponibility?.runValue && (
                                <div className=' mx-auto'>
                                  <ButtonForm 
                                    text={"Agregar campo"} 
                                    Icon={() => {return (<AddIco fill='white'/>)}} 
                                    enabled={!!selectedDisponibilityProcess && !fetchingDisponibilityParameters && disponibilityParameters.length!== 0}
                                    action={ () => setStage("setRunValue")}
                                  />
                                </div>
                              )}
                            </div>
                          </CollapsableSection>
                          
                          <CollapsableSection
                            title={"Valor paro produccion (datos numéricos)"}
                            titleBgColor='bg-aliceblue'
                            titleTextColor='text-gray'
                            open={true}
                          >
                            <div className='w-full flex flex-col px-4'>
                              { conf?.disponibility?.stopValue && (
                                <ColumnField header={conf?.disponibility?.stopValue} onDelete={deleteStopValue}/>
                              )}
                              { !conf?.disponibility?.stopValue && (
                                <div className=' mx-auto'>
                                  <ButtonForm 
                                    text={"Agregar campo"} 
                                    Icon={() => {return (<AddIco fill='white'/>)}} 
                                    enabled={!!selectedDisponibilityProcess && !fetchingDisponibilityParameters && disponibilityParameters.length!== 0}
                                    action={ () => setStage("setStopValue")}
                                  />
                                </div>
                              )}
                            </div>
                          </CollapsableSection>

                          <CollapsableSection 
                            title={"Variable de tiempo"}
                            titleBgColor='bg-aliceblue'
                            titleTextColor='text-gray'
                            open={true}
                          >
                            <div className='w-full flex flex-col px-4'>
                              { conf?.disponibility?.timeVar && (
                                <ColumnField header={conf?.disponibility?.timeVar} onDelete={deleteDispoTimeVar}/>
                              )}
                              { !conf?.disponibility?.timeVar && (
                                <div className=' mx-auto'>
                                  <ButtonForm 
                                    text={"Agregar campo"} 
                                    Icon={() => {return (<AddIco fill='white'/>)}} 
                                    enabled={!!selectedDisponibilityProcess && !fetchingDisponibilityParameters && disponibilityParameters.length!== 0}
                                    action={ () => setStage("setDispoTimeValue")}
                                  />
                                </div>
                              )}
                            </div>
                          </CollapsableSection>
                      </div>
                    </CollapsableSection>

                    {/* Eficiencia */}
                    <CollapsableSection 
                      CustomTitleBar={() => (
                        <span>Eficiencia</span>
                      )}
                      titleBgColor='bg-aliceblue'
                      titleTextColor='text-gray'
                    >
                      <div className='w-full flex flex-col px-4 gap-2'>
                        <div className='w-full flex flex-col px-4'>
                          <div className='flex justify-between items-center'>
                            <div className='w-[45%]'>
                              <SelectionForm
                                text="Proceso" 
                                options={Object.keys(processList)} 
                                mask={processList} 
                                value={selectedEfficiencyProcess}
                                onChange={event => setSelectedEfficiencyProcess(event)}
                                AppendClassName='-mb-5'
                                error={!!selectedEfficiencyProcess && !fetchingEfficiencyParameters && efficiencyParameters.length === 0 ? 'El proceso no tiene parametros creados' : ""}
                              /> 
                            </div>
                            <div className='relative flex '>
                              
                              <span className='absolute text-sm text-wrap'></span>
                            </div>
                            
                          </div>
                        </div>

                        <CollapsableSection
                          title={"Valor real (datos numéricos)"}
                          titleBgColor='bg-aliceblue'
                          titleTextColor='text-gray'
                          open={true}
                        >
                          <div className='w-full flex flex-col px-4'>
                            { conf?.efficiency?.realValue && (
                              <ColumnField header={conf?.efficiency?.realValue} onDelete={deleteRealValue}/>
                            )}
                            { !conf?.efficiency?.realValue && (
                              <div className=' mx-auto'>
                                <ButtonForm 
                                  text={"Agregar campo"} 
                                  Icon={() => {return (<AddIco fill='white'/>)}} 
                                  enabled={!!selectedEfficiencyProcess && !fetchingEfficiencyParameters && efficiencyParameters.length !== 0}
                                  action={ () => setStage("setRealValue")}
                                />
                              </div>
                            )}
                          </div>
                        </CollapsableSection>
                        
                        <CollapsableSection
                          title={"Valor ideal (datos numéricos)"}
                          titleBgColor='bg-aliceblue'
                          titleTextColor='text-gray'
                          open={true}
                        >
                          <div className='w-full flex flex-col px-4'>
                            { conf?.efficiency?.idealValue && (
                              <ColumnField header={conf?.efficiency?.idealValue} onDelete={deleteIdealValue}/>
                            )}
                            { !conf?.efficiency?.idealValue && (
                              <div className=' mx-auto'>
                                <ButtonForm 
                                  text={"Agregar campo"} 
                                  Icon={() => {return (<AddIco fill='white'/>)}} 
                                  enabled={!!selectedEfficiencyProcess && !fetchingEfficiencyParameters && efficiencyParameters.length !== 0}
                                  action={ () => setStage("setIdealValue")}
                                />
                              </div>
                            )}
                          </div>
                        </CollapsableSection>

                        <CollapsableSection 
                          title={"Variable de tiempo"}
                          titleBgColor='bg-aliceblue'
                          titleTextColor='text-gray'
                          open={true}
                        >
                          <div className='w-full flex flex-col px-4'>
                            { conf?.efficiency?.timeVar && (
                              <ColumnField header={conf?.efficiency?.timeVar} onDelete={deleteEffTimeVar}/>
                            )}
                            { !conf?.efficiency?.timeVar && (
                              <div className=' mx-auto'>
                                <ButtonForm 
                                  text={"Agregar campo"} 
                                  Icon={() => {return (<AddIco fill='white'/>)}} 
                                  enabled={!!selectedEfficiencyProcess && !fetchingEfficiencyParameters && efficiencyParameters.length!== 0}
                                  action={ () => setStage("setEffTimeValue")}
                                />
                              </div>
                            )}
                          </div>
                        </CollapsableSection>

                      </div>

                    </CollapsableSection>

                    {/* Calidad */}
                    <CollapsableSection 
                      CustomTitleBar={() => (
                        <span>Calidad</span>
                      )}
                      titleBgColor='bg-aliceblue'
                      titleTextColor='text-gray'
                    >
                      <div className='w-full flex flex-col px-4 gap-2'>
                        <div className='w-full flex flex-col px-4 '>
                          <div className='flex justify-between items-center'>
                            <div className='w-[45%]'>
                              <SelectionForm
                                text="Proceso" 
                                options={Object.keys(processList)} 
                                mask={processList} 
                                value={selectedQualityProcess}
                                onChange={event => setSelectedQualityProcess(event)}
                                AppendClassName='-mb-5'
                                error={!!selectedQualityProcess && !fetchingQualityParameters && qualityParameters.length === 0 ? 'El proceso no tiene parametros creados' : ""}
                              /> 
                            </div>
                            <div className='relative flex '>
                              
                              <span className='absolute text-sm text-wrap'></span>
                            </div>
                            
                          </div>
                        </div>

                        <CollapsableSection
                          title={"Valor conforme (datos numéricos)"}
                          titleBgColor='bg-aliceblue'
                          titleTextColor='text-gray'
                          open={true}
                        >
                          <div className='w-full flex flex-col px-4'>
                            { conf?.quality?.conformValue && (
                              <ColumnField header={conf?.quality?.conformValue} onDelete={deleteConformValue}/>
                            )}
                            { !conf?.quality?.conformValue && (
                              <div className=' mx-auto'>
                                <ButtonForm 
                                  text={"Agregar campo"} 
                                  Icon={() => {return (<AddIco fill='white'/>)}} 
                                  enabled={!!selectedQualityProcess && !fetchingQualityParameters && qualityParameters.length!== 0}
                                  action={ () => setStage("setConformValue")}
                                />
                              </div>
                            )}
                          </div>
                        </CollapsableSection>
                        
                        <CollapsableSection
                          title={"Valor NO conforme (datos numéricos)"}
                          titleBgColor='bg-aliceblue'
                          titleTextColor='text-gray'
                          open={true}
                        >
                          <div className='w-full flex flex-col px-4'>
                            { conf?.quality?.noConformValue && (
                              <ColumnField header={conf?.quality?.noConformValue} onDelete={deleteNoConformValue}/>
                            )}
                            { !conf?.quality?.noConformValue && (
                              <div className=' mx-auto'>
                                <ButtonForm 
                                  text={"Agregar campo"} 
                                  Icon={() => {return (<AddIco fill='white'/>)}} 
                                  enabled={!!selectedQualityProcess && !fetchingQualityParameters && qualityParameters.length!== 0}
                                  action={ () => setStage("setNoConformValue")}
                                />
                              </div>
                            )}
                          </div>
                        </CollapsableSection>

                        <CollapsableSection
                          title={"Merma (datos numéricos)"}
                          titleBgColor='bg-aliceblue'
                          titleTextColor='text-gray'
                          open={true}
                        >
                          <div className='w-full flex flex-col px-4'>
                            { conf?.quality?.reValue && (
                              <ColumnField header={conf?.quality?.reValue} onDelete={deleteReValue}/>
                            )}
                            { !conf?.quality?.reValue && (
                              <div className=' mx-auto'>
                                <ButtonForm 
                                  text={"Agregar campo"} 
                                  Icon={() => {return (<AddIco fill='white'/>)}} 
                                  enabled={!!selectedQualityProcess && !fetchingQualityParameters && qualityParameters.length!== 0}
                                  action={ () => setStage("setReValue")}
                                />
                              </div>
                            )}
                          </div>
                        </CollapsableSection>

                        <CollapsableSection 
                          title={"Variable de tiempo"}
                          titleBgColor='bg-aliceblue'
                          titleTextColor='text-gray'
                          open={true}
                        >
                          <div className='w-full flex flex-col px-4'>
                            { conf?.quality?.timeVar && (
                              <ColumnField header={conf?.quality?.timeVar} onDelete={deleteQATimeVar}/>
                            )}
                            { !conf?.quality?.timeVar && (
                              <div className=' mx-auto'>
                                <ButtonForm 
                                  text={"Agregar campo"} 
                                  Icon={() => {return (<AddIco fill='white'/>)}} 
                                  enabled={!!selectedQualityProcess && !fetchingQualityParameters && qualityParameters.length!== 0}
                                  action={ () => setStage("setQATimeValue")}
                                />
                              </div>
                            )}
                          </div>
                        </CollapsableSection>
                      </div>
                    </CollapsableSection>

                    <div className='-mb-5 pt-4'>
                      <InputForm 
                        type={"datarange"} 
                        text={"Rango de tiempo"} 
                        value={dataRange} 
                        AppendClassName='text-left' 
                        onChange={(event) => handleDataRangeChange(event)}
                        dateRangeOptions={conf.dateRange}
                        addedRanges={ {"byDashboard": () => {}}} 
                      />
                    </div>
                  </div>
                  

                </CollapsableSection>
                <CollapsableSection title={"Apariencia"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' border={false} open={true}>
                  <div className='-mb-4 '>
                    <InputForm text={"Nombre"} value={title} onChange={(event) => setTitle(event.target.value)}/>
                  </div>
                  <div className='-mb-4 pt-2'>
                    <InputForm type={"number"} text={"Decimales"} value={conf.nDecimals} onChange={(event) => handleDecimalsChange(event.target.value)}/>
                  </div>
                  {!conf.hasInterval &&(
                    <div className='w-full -mb-4 pt-2'>
                      <SelectionForm
                        text="TIpo de grafica" 
                        options={Object.keys(graphTypes)} 
                        mask={graphTypes} 
                        value={conf.graphType}
                        onChange={event => handleGraphType(event)}
                        AppendClassName=' '
                      /> 
                    </div>
                    
                  )}
                  <div className='-mb-4 pt-2'>
                    <InputForm type={"button"} text={"Estilo"} value={"Modificar estilo"} AppendClassName='text-left' onClick={() => {setStage("setAparience")}}/>
                  </div>
                </CollapsableSection>
              </div>

            {/* Span fijo al final del contenedor */}
            <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
              <div className='flex w-full justify-end'>
                <button className='' onClick={() => id ? handleEditWidget() : handleCreateWidget()}  disabled={!validate}>
                  <CheckIco width='50px' height='50px' fill={validate ? 'bluesens': 'gray'}/>
                </button>
              </div>
            </div>
          </div>
        )}
        {(!conf || fetchingWidgetInfo) && (
          <Spinner />
        )}
      </>
      
      
     )}
     {/* stage === "setTimeValue" && (
      <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
        <div className=' flex flex-col flex-grow gap-2'>
          <span className='font-semibold text-lg'>{processList[selectedProcess]}</span>
          <DropdownSelectableList 
            items={parameters.filter(element => element.type === "date").map(element => element.alias ? element.alias : element.key)} 
            multiSelect={false} 
            setItems={selectVariableToCompare}/>
        </div>
        
        {/* Span fijo al final del contenedor 
        <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
          <div className='flex w-full justify-end'>
            < ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
          </div>
        </div>
      </div>
     ) */
     }

     {/* Efficiencia */}
     {stage === "setRealValue" &&
      renderStage("efficiency", "realValue", selectedEfficiencyProcess, efficiencyParameters, " - Eficiencia. Valor real")}

    {stage === "setIdealValue" &&
      renderStage("efficiency", "idealValue", selectedEfficiencyProcess, efficiencyParameters," - Eficiencia. Valor ideal")}
    {stage === "setEffTimeValue" &&
      renderTimeVarStage(
      "efficiency",
      selectedEfficiencyProcess,
      efficiencyParameters,
      "Eficiencia. Variable de tiempo"
    )}

    {/* Disponibilidad */}
    {stage === "setRunValue" &&
      renderStage("disponibility", "runValue", selectedDisponibilityProcess, disponibilityParameters," - Disponibilidad. Valor prod")}

    {stage === "setStopValue" &&
      renderStage("disponibility", "stopValue", selectedDisponibilityProcess, disponibilityParameters," - Disponibilidad. Valor paro")}
    {stage === "setDispoTimeValue" &&
      renderTimeVarStage(
      "efficiency",
      selectedDisponibilityProcess,
      disponibilityParameters,
      "Eficiencia. Variable de tiempo"
    )}

    {/* Calidad */}
    {stage === "setConformValue" &&
      renderStage("quality", "conformValue", selectedQualityProcess, qualityParameters," - Calidad. Valor conforme")}
    {stage === "setNoConformValue" &&
    renderStage("quality", "noConformValue", selectedQualityProcess, qualityParameters," - Calidad. Valor NO conforme")}
    {stage === "setReValue" &&
    renderStage("quality", "reValue", selectedQualityProcess, qualityParameters," - Calidad. Valor reprocesado")}
    {stage === "setQATimeValue" &&
      renderTimeVarStage(
      "efficiency",
      selectedQualityProcess,
      qualityParameters,
      "Eficiencia. Variable de tiempo"
    )}
     {/* Apariencia */} 
      {stage === "setAparience" && (
        <div className="flex flex-col gap-2 h-[25rem] relative overflow-auto">
          <div className="flex flex-col flex-grow gap-2">
            <span className="font-semibold text-lg">Modificar estilo</span>
            <div className="pt-2">
              <WidgetHeaderStyleFields
                headerColor={conf?.headerColor}
                headerTextColor={conf?.headerTextColor}
                onChange={(field, val) => setConf(prev => ({ ...prev, [field]: val }))}
              />
            </div>

            {/* Selección de paleta de colores */}
            <span className='text-sm font-medium text-gray-500 mt-1'>Gráfico</span>
            <SelectionForm
              id="colorPalette"
              text="Paleta de colores"
              options={Object.keys(colorOptions)}
              mask={colorOptions}
              value={conf?.colorPalette || "pastel"}
              onChange={(event) => selectColorPalette(event)}
            compact
            />

            {/* Mostrar el color fijo solo si se selecciona esa opción */}
            {conf?.colorPalette === "fixed" && (
              <InputForm
                id="fixedColor"
                type="color"
                text="Seleccionar color fijo"
                value={conf?.fixedColor || "#4287f5"}
                onChange={(event) => selectFixedColor(event)}
              compact
              />
            )}
            <InputForm
              id="textColor"
              type="color"
              text="Seleccionar color del texto"
              value={conf?.textColor || "#000000"}
              onChange={(event) => selectTextColor(event)}
            compact
            />
          </div>

          {/* Botón fijo al final */}
          <div className="flex-none sticky bottom-0 bg-white p-2 shadow-lg">
            <div className="flex w-full justify-end">
              <ButtonForm
                text={"Guardar"}
                enabled={true}
                action={() => setStage("form")}
              />
            </div>
          </div>
        </div>
      )}
    </>
   
    
  );
}

export default OEEForm;
